module.exports = __webpack_public_path__ + "img/logo.3a9676b7.png";